import LocalStorageHelper from './local-storage-helper';
import geolocation from './geolocation';

function createStorageAccessors(key) {
  return {
    get: () => LocalStorageHelper.get(key, []),
    set: (value) => LocalStorageHelper.set(key, value),
    clear: () => LocalStorageHelper.set(key, []),
    append: (...args) => LocalStorageHelper.append(key, ...args),
    remove: (...args) => LocalStorageHelper.remove(key, ...args)
  };
}

export const FavoriteStorage = createStorageAccessors('events_favorite');
export const SearchedStorage = createStorageAccessors('events_search');

export async function trackUserView() {
  const genericData = getGenericData('view');

  const saveWithFallback = async (errorType, errorMessage) => {
    if (errorMessage) console.warn(`${errorType}: ${errorMessage}`);
    console.log('Iniciando fallback: buscando dados de São Paulo via API.');

    try {
      const response = await $.ajax({
        url: '/json/busca-por-nome',
        type: "POST",
        dataType: "json",
        data: { name: 'São Paulo' }
      });

      const saoPauloData = response?.[0]?.response?.data?.[0];

      if (saoPauloData) {
        genericData.city = LocalStorageHelper.mapCityData(saoPauloData);
      } else {
        genericData.city = null;
        console.warn('API de busca não retornou dados para o fallback de São Paulo.');
      }
    } catch (apiError) {
      genericData.city = null;
      console.error('Falha ao buscar dados de fallback da API:', apiError);
    }

    genericData.is_fallback = true;
    setViewData(genericData);
  };

  geolocation.getUserLocation(
    (position) => {
      LocalStorageHelper.set('last_known_location', {
        lat: position.coords.latitude,
        lon: position.coords.longitude
      });

      const url = "/json/minha-localizacao";
      const xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = async function () {
        if (this.readyState === 4) {
          if (this.status === 200) {
            let response;
            try {
              response = JSON.parse(this.response);
            } catch (e) {
              await saveWithFallback("Resposta inválida da API", e.message);
              return;
            }
            const locationData = response?.data?.[0];
            if (locationData) {
              genericData.city = LocalStorageHelper.mapCityData(locationData);
              genericData.is_fallback = false;
              console.log('Dados de cidade obtidos via API:', genericData.city.cname);
              setViewData(genericData);
            } else {
              await saveWithFallback("Dados de cidade não encontrados na resposta da API");
            }
          } else {
            await saveWithFallback("Falha na requisição à API de localização", `Status: ${this.status}`);
          }
        }
      };
      xhttp.open("POST", url, true);
      xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xhttp.send(`latitude=${position.coords.latitude}&longitude=${position.coords.longitude}`);
    },
    async (error) => {
      await saveWithFallback("Permissão de geolocalização negada", error.message);
    }
  );
}

export function getUserViewData(pageCityData = null) {
  const genericData = getGenericData('view');
  const treatedCityData = pageCityData ? LocalStorageHelper.mapCityData(pageCityData) : null

  const data = {
    ...genericData,
    city: treatedCityData
  }
  setViewData(data);
}


export function checkLocationChange() {
  console.log('Verificando se a localização mudou...');
  const lastKnownLocation = LocalStorageHelper.get('last_known_location');

  if (!lastKnownLocation) {
    console.log('Nenhuma localização anterior guardada. A verificação termina.');
    return;
  }

  geolocation.getUserLocation(
    (currentPosition) => {
      const newCoords = {
        lat: currentPosition.coords.latitude,
        lon: currentPosition.coords.longitude
      };
      const threshold = 0.001;
      const latChanged = Math.abs(newCoords.lat - lastKnownLocation.lat) > threshold;
      const lonChanged = Math.abs(newCoords.lon - lastKnownLocation.lon) > threshold;

      if (latChanged || lonChanged) {
        console.log('Mudança de localização detectada! Atualizando dados...');
        trackUserView();
      } else {
        console.log('A localização não mudou significativamente.');
      }
    },
    (error) => {
      console.warn('Não foi possível obter a localização atual para verificação.', error.message);
    }
  );
}

export function setViewData(genericData) {
  const viewData = {
    ...genericData
  };
  const existing = LocalStorageHelper.get('events_view', []);
  const lastViewForThisUrl = existing.slice().reverse().find(d => d.url === viewData.url);

  if (!lastViewForThisUrl) {
    LocalStorageHelper.append('events_view', viewData);
    return;
  }

  const lastTimestamp = new Date(lastViewForThisUrl.ts);
  const currentTimestamp = new Date(viewData.ts);
  const differenceInMillis = currentTimestamp - lastTimestamp;
  const oneMinuteInMillis = 60 * 1000;

  if (differenceInMillis > oneMinuteInMillis) {
    LocalStorageHelper.append('events_view', viewData);
  }
}

export function getGenericData(type) {
  const genericData = {
    t: type,
    ts: new Date().toLocaleString('sv-SE', {
      timeZone: 'America/Sao_Paulo', hour12: false
    }).replace(' ', 'T'),
    dc: getDeviceData(),
    sec: getSectionFromUrl(),
    url: window.location.href
  };
  return genericData;
}

export function getDeviceData() {
  const ua = navigator.userAgent;
  if (/Mobi|Android/i.test(ua)) return "mobile";
  if (/Tablet|iPad/i.test(ua)) return "tablet";
  return "desktop";
}

export function getSectionFromUrl() {
  const path = window.location.pathname;

  const routePatterns = [
    { regex: /^\/previsao-do-tempo\/agora\/cidade/, section: 'now' },
    { regex: /^\/previsao-do-tempo\/amanha\/cidade/, section: 'tomorrow' },
    { regex: /^\/previsao-do-tempo\/fim-de-semana\/cidade/, section: 'weekend' },
    { regex: /^\/previsao-do-tempo\/15-dias\/cidade/, section: 'fifteen' },
    { regex: /^\/previsao-do-tempo\/cidade/, section: 'today' },

    { regex: /^\/noticias/, section: 'news' },
    { regex: /^\/destaques/, section: 'news' },
    { regex: /^\/noticia/, section: 'news' },
    { regex: /^\/graficos/, section: 'charts' },
    { regex: /^\/climatologia/, section: 'climatology' },
    { regex: /^\/satelite/, section: 'satellite' },
    { regex: /^\/podcast/, section: 'podcast' },
    { regex: /^\/podcasts/, section: 'podcast' },
    { regex: /^\/uv/, section: 'uv' },
    { regex: /^\/vento/, section: 'wind' },
    { regex: /^\/previsao-por-email/, section: 'email' },
    { regex: /^\/videos/, section: 'videos' },
    { regex: /^\/clima-de-viagem/, section: 'travel' },
    { regex: /^\/verao/, section: 'summer' },
    { regex: /^\/agroclima/, section: 'agroclima' },
    { regex: /^\/inverno/, section: 'winter' },
    { regex: /^\/$/, section: 'home' },
    { regex: /^\/brasil/, section: 'brazil' },
    { regex: /^\/beachInfo/, section: 'beach' },
    { regex: /^\/previsao-do-tempo\/litoral/, section: 'beach' },
    { regex: /^\/previsao-do-tempo\/aeroporto/, section: 'airport' }
  ];

  for (const route of routePatterns) {
    if (route.regex.test(path)) {
      return route.section;
    }
  }

  return 'home';
}
